import * as React from "react";
const SvgFiRr7 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-7_svg__a)">
      <path
        fill="#062147"
        d="M7.999 24a1 1 0 0 1-.877-1.48l10.84-19.829c.096-.193.005-.383-.039-.455a.5.5 0 0 0-.425-.237H5a1 1 0 0 1 0-2h12.498a2.48 2.48 0 0 1 2.126 1.186c.459.742.5 1.651.11 2.433L8.877 23.479a1 1 0 0 1-.878.521"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-7_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRr7;
